import { Form, Input, Modal, Upload } from "antd";
import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../AccommodationData/CustomButton/CustomButton";
import { RcFile } from "antd/es/upload";
import { uploadFile } from "../../services/FileService";
import { Toast } from "primereact/toast";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import "./modalNewLecturer.scss";
import { v4 as uuidv4 } from "uuid";

function ModalNewLecturer(props: any) {
  const toast = useRef<any>(null);
  const [photo, setPhoto] = useState<any>();
  const [loading, setLoading] = useState(false);
  ///// PATH FOR IMAGES
  let serverUrl = process.env.REACT_APP_API_URL;
  let storageUrl = serverUrl + "files/storage/";
  ///// END PATH FOR IMAGES
  const [inputValues, setInputValues] = useState({
    firstName: "",
    lastName: "",
    serialNumber: "",
    biography: "",
    id: "",
  });

  const [validation, setValidation] = useState({
    firstName: true,
    lastName: true,
    serialNumber: true,
  });

  const validateFields = () => {
    const isFirstNameValid = inputValues.firstName.trim() !== "";
    const isLastNameValid = inputValues.lastName.trim() !== "";
    const isSerialNumberValid = inputValues.serialNumber.trim() !== "";

    setValidation({
      firstName: isFirstNameValid,
      lastName: isLastNameValid,
      serialNumber: isSerialNumberValid,
    });

    return isFirstNameValid && isLastNameValid && isSerialNumberValid;
  };

  useEffect(() => {
    if (props?.oneLecturer) {
      setInputValues({ ...props?.oneLecturer });
      setPhoto(props?.oneLecturer?.photo);
    }
  }, [props]);

  const beforeUpload = (file: RcFile) => {
    // Provera tipa i veličine fajla pre slanja
    const allowedTypes = ["image/jpeg", "image/png"];
    const isAllowedType = allowedTypes.includes(file.type);
    const isAllowedSize = file.size / 1024 / 1024 < 50; // Maksimalna veličina 5MB

    if (!isAllowedType) {
      toast?.current?.show({
        severity: "error",
        detail: "Dozvoljeni formati slika su JPEG i PNG!",
        life: 3000,
      });
    }

    if (!isAllowedSize) {
      toast?.current?.show({
        severity: "error",
        detail: "Slika ne sme biti veća od 50MB!",
        life: 3000,
      });
    }

    return isAllowedType && isAllowedSize;
  };

  ////// UPLOAD IMAGE
  const handleUpload = async (file: any) => {
    try {
      const response = await uploadFile(file.file);
      const uploadedPhotoWithBackend = response.data;
      // props.uploadImageFunc(uploadedPhotoWithBackend);
      setPhoto(uploadedPhotoWithBackend);

      toast?.current?.show({
        severity: "success",
        detail: "Slika je uspešno uploadovana!",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast?.current?.show({
        severity: "error",
        detail: "Došlo je do greške prilikom uploada slike.",
        life: 3000,
      });
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const saveLecturer = () => {
    const isFieldsValid = validateFields();

    if (isFieldsValid) {
      const duplicateSerialNumber = props?.allLecturers?.some(
        (lecturer: any) => lecturer.serialNumber === inputValues.serialNumber
      );

      if (duplicateSerialNumber) {
        toast?.current?.show({
          severity: "error",
          detail: "Predavač sa istim rednim brojem već postoji!",
          life: 3000,
        });
      } else {
        let id = uuidv4();
        let sendLecturerData = { ...inputValues, photo: photo, id: id };
        props.saveLecturer(sendLecturerData);
        props.triggerModalFunc(false);

        setInputValues({
          firstName: "",
          lastName: "",
          serialNumber: "",
          biography: "",
          id: "",
        });

        setPhoto(undefined);
        resetInputsData();
      }
    }
  };

  const resetInputsData = () => {
    setInputValues({
      firstName: "",
      lastName: "",
      serialNumber: "",
      biography: "",
      id: "",
    });

    setPhoto(undefined);
    props.resetDataLecturer();
  };

  const editLecturer = () => {
    const isFieldsValid = validateFields();

    if (isFieldsValid) {
      const duplicateSerialNumber = props?.allLecturers?.some(
        (lecturer: any) => lecturer.serialNumber === inputValues.serialNumber
      );

      const find = props?.allLecturers?.find(
        (lecturer: any) => lecturer.id === inputValues.id
      );

      if (
        duplicateSerialNumber &&
        inputValues.serialNumber !== find.serialNumber
      ) {
        toast?.current?.show({
          severity: "error",
          detail: "Predavač sa istim rednim brojem već postoji!",
          life: 3000,
        });
      } else {
        let sendLecturerData = { ...inputValues, photo: photo };
        props.editLecturerFunc(sendLecturerData);
        props.triggerModalFunc(false);

        setInputValues({
          firstName: "",
          lastName: "",
          serialNumber: "",
          biography: "",
          id: "",
        });

        setPhoto(undefined);
        resetInputsData();
      }
    }
  };

  return (
    <>
      <Toast ref={toast} position={"top-right"} />
      <Modal
        maskClosable={false}
        open={props.openViewModal}
        style={{ minWidth: "700px" }}
        title={`Novi predavač`}
        onCancel={() => {
          props.triggerModalFunc(false);
          resetInputsData();
        }}
        onOk={() => props.triggerModalFunc(false)}
        footer={
          props?.oneLecturer ? (
            <>
              {" "}
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={1}
                type={"primary"}
                function={() => {
                  editLecturer();
                }}
                text={"Uredi"}
              />{" "}
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={2}
                type={"primary"}
                function={() => {
                  props.triggerModalFunc(false);
                  resetInputsData();
                }}
                text={"Zatvori"}
              />
            </>
          ) : (
            <>
              {" "}
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={1}
                type={"primary"}
                function={() => {
                  saveLecturer();
                }}
                text={"Potvrdi"}
              />{" "}
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={2}
                type={"primary"}
                function={() => {
                  props.triggerModalFunc(false);
                  resetInputsData();
                }}
                text={"Zatvori"}
              />
            </>
          )
        }
      >
        <div className="modal-lecturer">
          <div className="avatar-image">
            <label>Izaberi sliku predača:</label>
            <Upload
              name="avatar"
              beforeUpload={beforeUpload}
              accept="image/*"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              customRequest={(file) => {
                handleUpload(file);
              }}
            >
              {photo ? (
                <div className="image-div-avatar">
                  <img
                    src={`${storageUrl}${photo?.id}`}
                    alt="avatar"
                    // style={{ width: "100%" }}
                  />
                  <div
                    className="delete-avatar-image"
                    onClick={() => {
                      setPhoto(undefined);
                    }}
                  >
                    Delete
                  </div>
                </div>
              ) : (
                uploadButton
              )}
            </Upload>
          </div>
          <div className="personal-data-modal">
            <Form.Item
              label="Ime"
              validateStatus={!validation.firstName ? "error" : ""}
            >
              <Input
                className="input-label"
                placeholder="Unesite ime"
                name="firstName"
                value={inputValues.firstName}
                onChange={handleInputChange}
              />
            </Form.Item>
            <Form.Item
              label="Prezime"
              validateStatus={!validation.lastName ? "error" : ""}
            >
              <Input
                className="input-label"
                placeholder="Unesite prezime"
                name="lastName"
                value={inputValues.lastName}
                onChange={handleInputChange}
              />
            </Form.Item>
            <Form.Item
              label="Redni broj"
              validateStatus={!validation.serialNumber ? "error" : ""}
            >
              <Input
                className="input-label"
                placeholder="Unesite redni broj"
                name="serialNumber"
                value={inputValues.serialNumber}
                onChange={handleInputChange}
              />
            </Form.Item>
          </div>
          <div className="bio">
            <label>Biografija:</label>
            <textarea
              name="biography"
              onChange={handleInputChange}
              value={inputValues.biography}
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ModalNewLecturer;
